import { render, staticRenderFns } from "./OrgAdminDashboard.vue?vue&type=template&id=a96f6562&"
import script from "./OrgAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports